import Phaser from "phaser";
import { AuthScene } from "./scenes/AuthScene";
import { CharacterScene } from "./scenes/CharacterScene";
import { GameScene } from "./scenes/GameScene";

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: window.innerWidth,
  height: window.innerHeight,
  backgroundColor: "#1a1a2e",
  pixelArt: true, // crisp 16px tiles at 2x camera zoom
  // Text objects render sharp via their own setResolution() (see GameScene) —
  // Phaser 3.60+ dropped the game-level `resolution` config option.
  scene: [AuthScene, CharacterScene, GameScene],
  physics: {
    default: "arcade",
    arcade: { gravity: { x: 0, y: 0 }, debug: false },
  },
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
};

new Phaser.Game(config);
